export { StudentCloseAccountPage } from "./StudentCloseAccountPage"
export type { StudentCloseAccountPageProps } from "./StudentCloseAccountPage"
